import {
    InspectionGroup,
    translateInspectionGroup,
} from 'aos-services/src/services/tasks/types/task/InspectionGroup'
import { Box, colors, Icon, Pressable, Text } from 'aos-ui-universal'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { inspectionGroupIcons } from '../../../../utils'
import { taskChip } from '../../taskChip'
import { InspectionSelectedCounter } from './InspectionSelectedCounter'

const inspectionChipLayout =
    'relative min-h-[80px] flex-col items-center justify-end gap-1 px-2 py-2'

interface InspectionTypeIconRendererProps {
    isSelected: boolean
    group: InspectionGroup
    isLate: boolean
    onSelect(): void
    selectedInspectionsCounter: number
    inspectionTotalNumber: number
}

export const InspectionTypeIconRenderer: FC<InspectionTypeIconRendererProps> = ({
    isSelected,
    isLate,
    onSelect,
    group,
    inspectionTotalNumber,
    selectedInspectionsCounter,
}) => {
    const { t: translate } = useTranslation()
    return (
        <Pressable
            accessibilityRole='radio'
            accessibilityState={{ selected: isSelected }}
            onPress={onSelect}
            className={taskChip({ isSelected, class: inspectionChipLayout })}
        >
            {isLate && (
                <Box className='absolute left-1 top-1 h-[10px] w-[10px] rounded-full bg-graphics-orange' />
            )}
            {selectedInspectionsCounter > 0 && (
                <InspectionSelectedCounter
                    selectedInspectionsCounter={selectedInspectionsCounter}
                    inspectionTotalNumber={inspectionTotalNumber}
                />
            )}
            <Icon
                as={inspectionGroupIcons[group]}
                size={24}
                className={isSelected ? 'text-aos-text-on-primary' : 'text-aos-text-default'}
            />
            <Text
                size='body'
                tone={isSelected ? 'on-primary' : 'default'}
                numberOfLines={2}
                className='text-center'
            >
                {translateInspectionGroup(translate)(group)}
            </Text>
            {isLate && (
                <Text size='caption' color={colors.graphics.orange} className='text-center'>
                    {translate('form.inspection-late', { ns: 'tasks' })}
                </Text>
            )}
        </Pressable>
    )
}
